var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_427_5142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.645 7.44975H2.23495M11.92 1.48975V4.46975M5.95995 1.48975V4.46975M5.81095 16.3897H12.069C13.3207 16.3897 13.9465 16.3897 14.4246 16.1461C14.8452 15.9319 15.1871 15.59 15.4014 15.1694C15.645 14.6913 15.645 14.0655 15.645 12.8137V6.55575C15.645 5.30403 15.645 4.67817 15.4014 4.20008C15.1871 3.77954 14.8452 3.43762 14.4246 3.22335C13.9465 2.97975 13.3207 2.97975 12.069 2.97975H5.81095C4.55924 2.97975 3.93338 2.97975 3.45529 3.22335C3.03474 3.43762 2.69283 3.77954 2.47856 4.20008C2.23495 4.67817 2.23495 5.30403 2.23495 6.55575V12.8137C2.23495 14.0655 2.23495 14.6913 2.47856 15.1694C2.69283 15.59 3.03474 15.9319 3.45529 16.1461C3.93338 16.3897 4.55924 16.3897 5.81095 16.3897Z",
    stroke: "white",
    strokeWidth: 1.54348,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_5142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.88,
    height: 17.88,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.34765e836069ad500e97da81e9e3a991.svg";
export { ForwardRef as ReactComponent };